import React from "react";
import styles from './noResults.module.scss';
import { useI18N } from '../../../../../hooks';

function NoResults() {
  const i18n = useI18N();
  return (
    <>

      <div className={styles.noResults}>
        <div
          className={`d-flex flex-column align-items-center justify-content-center`}
          style={{ height: "100%", width: `100%` }}
        >
          <div className={styles.icon}>
            <i className="fad fa-search text-info"></i>
            <i className="fad fa-sad-tear text-info"></i>
          </div>
          <h5 className="pt-3 text-info">{i18n.translateThis('Sorry, No Results', i18n.localize.sorryNoResults)}...</h5>
        </div>
      </div>

    </>
  );
}

export default React.memo(NoResults);
